import { SxProps, Theme } from '@mui/material';

export const titleCategoryDepartureMenSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-sm)',
		sm: 'var(--font-size-md)',
	},
	fontWeight: {
		xs: '900',
		sm: 'bold',
	},
	color: 'text.primary',
	textAlign: {
		xs: 'center',
		sm: 'start',
	},
};

export const subtitleCategoryDepartureMenSX: SxProps<Theme> = {
	fontWeight: 'normal',
	color: 'text.primary',
	fontSize: 'var(--font-size-body)',
	textAlign: {
		xs: 'center',
		sm: 'start',
	},
};

